import { Injectable } from '@angular/core';
import atlas from 'azure-maps-control';
import * as atlasService from 'azure-maps-rest';
import { AzureWrapperServices, MessageTransportService } from '@nx-fe/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SspDeviceAddressService {
  private atlasServiceTimeout: 10000;
  private searchURL: atlasService.SearchURL;

  constructor(
    private _azureWrapperService: AzureWrapperServices,
    private _messageTransportService: MessageTransportService
  ) {
    this._messageTransportService.event('azureWrapperPipelineBuilt').subscribe(built => {
      this.searchURL = this._azureWrapperService.searchURL();
    });
  }

  async getAddress(latitude: number, longitude: number): Promise<string> {
    return await this.searchURL
      ?.searchAddressReverse(
        atlasService.Aborter.none.withTimeout(this.atlasServiceTimeout),
        new atlas.data.Position(longitude, latitude)
      )
      .then(locationDetails => {
        if (locationDetails && locationDetails?.addresses && locationDetails.addresses?.length > 0) {
          return locationDetails.addresses[0].address.freeformAddress;
        }
      });
  }
}
